import { combineReducers } from "redux";
import StudentAdminReducer from "./StudentAdminReducer";
import { studentApprovedCoursesReducer } from "./StudentApprovedCoursesReducer";
import TeacherApprovedCoursesReducer from "./TeacherApprovedCoursesReducer";
import addLessonReducer from "./addLessonReducer";
import adminApprovedCoursesReducer from "./adminApprovedCoursesReducer";
import adminCourseTreeReducer from "./adminCourseTreeReducer";
import authReducer from "./authReducer";
import { contentFetchReducer, contentUploadReducer } from "./contentReducer";
import {
  courseAdminReducer,
  courseApprovalsReducer,
} from "./courseAdminReducer";
import createCourseReducer from "./courseCreateReducer";
import courseReducer from "./courseReducer";
import courseTreeReducer from "./courseTreeReducer";
import einstufungReducer from "./einstufungReducer";
import enrollReducer from "./enrollReducer";
import enrolledCourseDetailsReducer from "./enrolledCourseDetailsReducer";
import enrolledStudentCoursesReducer from "./enrolledStudentCoursesReducer";
import errorReducer from "./errorReducer";
import fetchLessonReducer from "./fetchLessonReducer";
import forgetPasswordReducer from "./forgetPasswordReducer";
import { instaPayReducer } from "./instaPayReducer";
import lessonCourseTreeReducer from "./lessonCourseTreeReducer";
import lessonUpdateReducer from "./lessonUpdateReducer";
import manageStudentsReducer from "./manageStudentsReducer";
import notificationReducer from "./notificationReducer";
import placementSecurityReducer from "./placementSecurityReducer";
import { studentCourseRequestReducer } from "./studentCourseRequestReducer";
import studentCourseTreeReducer from "./studentCourseTreeReducer";
import studentDetailsReducer from "./studentDetailsReducer";
import studentPlacementAnswersReducer from "./studentPlacementAnswersReducer"; // <-- student placement answers reducer
import studentPlacementReducer from "./studentPlacementReducer";
import { studentReducer } from "./studentReducer";
import { studentRequestUpdateReducer } from "./studentRequestUpdateReducer";
import teacherAdminReducer, {
  teacherDetailsAdminReducer,
} from "./teacherAdminReducer"; // Correct import
import teacherManagerReducer from "./teacherManagerReducer";
import teacherPlacementReducer from "./teacherPlacementReducer"; // <-- teacher placement reducer
import teacherProfileReducer from "./teacherProfileReducer";
import { updateTeacherRoleReducer } from "./updateTeacherRoleReducer";
import teacherCoursesReducer from "./adminDeveloperTeacherCoursesReducer";
import studentCoursesReducer from "./studentCoursesReducer";  // adminDeveloperStudentCoursesReducer
import {contactUsReducer} from "./contactUsReducer";
import { teacherManagerCourseReducer } from "./teacherManagerCourseReducer"; // ✅ Import the new reducer
import { consultantReducer } from "./consultantReducer";
import { adminReducer } from "./adminReducer";
const appReducer = combineReducers({
  errors: errorReducer,
  auth: authReducer,
  course: courseReducer,
  student: studentReducer,
  createCourse: createCourseReducer, // New reducer for creating courses
  forgetPassword: forgetPasswordReducer,
  teacherAdmin: teacherAdminReducer, // Default export
  courseAdmin: courseAdminReducer, // Pending courses reducer
  courseApprovals: courseApprovalsReducer, // Approved courses reducer
  teacherDetails: teacherDetailsAdminReducer, // Named export
  studentAdmin: StudentAdminReducer, // Add the StudentAdminReducer
  teacherApprovedCourses: TeacherApprovedCoursesReducer,
  studentApprovedCourses: studentApprovedCoursesReducer,
  enrollment: enrollReducer, // Add the enrollment reducer to the root reducer
  enrolledStudentCourses: enrolledStudentCoursesReducer,
  enrolledCourseDetails: enrolledCourseDetailsReducer,
  manageStudents: manageStudentsReducer,
  studentDetails: studentDetailsReducer,
  courseTree: courseTreeReducer,
  addLesson: addLessonReducer,
  fetchLesson: fetchLessonReducer,
  updateLesson: lessonUpdateReducer,
  contentUpload: contentUploadReducer,
  fetchContent: contentFetchReducer,
  studentCourseTree: studentCourseTreeReducer,
  instaPayStatus: instaPayReducer,
  adminCourseTree: adminCourseTreeReducer,
  adminApprovedCourses: adminApprovedCoursesReducer,
  studentCourseRequests: studentCourseRequestReducer,
  studentRequestUpdate: studentRequestUpdateReducer,
  teacherRoleUpdate: updateTeacherRoleReducer,
  lessonCourseTree: lessonCourseTreeReducer,
  notification: notificationReducer,
  teacherProfile: teacherProfileReducer,
  teacherManager: teacherManagerReducer, // ✅ Add this line
  einstufung: einstufungReducer,
  placementSecurity: placementSecurityReducer,
  studentPlacement: studentPlacementReducer, // <-- student slice
  studentPlacementAnswers: studentPlacementAnswersReducer, // <-- student placement answers slice
  teacherPlacement: teacherPlacementReducer,
  teacherCourses: teacherCoursesReducer,
  studentCourses: studentCoursesReducer,
  teacherManagerCourses: teacherManagerCourseReducer,
  consultant: consultantReducer,
  admin: adminReducer,



  contactUs: contactUsReducer,
  // Add other reducers here
});
const rootReducer = (state, action) => {
  if (action.type === "LOGOUT") {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
